module.exports = __webpack_public_path__ + "static/media/linkedin.65220039.svg";